const getters = {
    isEmpty(state) {
        return (obj, subobj=null) => {
            if (subobj) {
                return (typeof state[obj] === 'object' && typeof state[obj][subobj] === 'object') ? !Object.keys(state[obj][subobj]).length : true;
            } else {
                return typeof state[obj] === 'object' ? !Object.keys(state[obj]).length : true;
            }
        }
    },
    errors(state) {
        return state.errors;
    },
    fetchCount(state) {
        return state.count;
    },
    fetchNext(state) {
        return state.next;
    }
}

export default getters;
